import { LINKS } from '@trip-ux/constants';
import axios from 'axios';
import { get } from 'lodash';
import { ReduxStore } from '../payload-types';
import { fork, select, call, take, put } from 'redux-saga/effects';
import { AGENCY_ORGANIZATION_SEARCH, AGENCY_ORGANIZATION_SEARCH_RESULT } from './types';
import { sortArray } from '../utils';

const getAgencyOrganizationList = (state: ReduxStore, payload) =>
  axios
    .post(`${get(state, 'config.options.contextPath', '')}${LINKS.EXTRNL_REPORT_ORG_LIST}`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => get(res, 'data', []))
    .catch(() => []);

function* watchAgencyOrganizationSearchRequest() {
  while (true) {
    const { payload } = yield take(AGENCY_ORGANIZATION_SEARCH);
    const state: ReduxStore = yield select((store: ReduxStore) => store);
    const organizations = yield call(getAgencyOrganizationList, state, payload);
    const sortedOrganizations = sortArray(organizations, state.config.locale);
    yield put({ type: AGENCY_ORGANIZATION_SEARCH_RESULT, payload: sortedOrganizations });
  }
}

export default [fork(watchAgencyOrganizationSearchRequest)];
